// FIRST: initializes logClient before App's error handlers wire up window.onerror.
import "./logClientInit";
import ReactDOM from "react-dom/client";
import App from "./App";

const root = document.getElementById("root");
if (!root) throw new Error("couldn't find #root element");

ReactDOM.createRoot(root).render(<App />);
